<template>
  <menu-item :title="iconTitle" :icon-name="iconName" @click="toggleHidePageElements"></menu-item>
</template>

<script>
import MenuItem from '@/components/MenuItem'
import { mapGetters, mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['toggleHidePageElements'])
  },
  computed: {
    ...mapGetters(['hidePageElements']),
    iconName () {
      return this.hidePageElements ? 'icon-eye' : 'icon-eye-slash'
    },
    iconTitle () {
      return this.hidePageElements ? 'Vis lydelementer' : 'Skjul lydelementer'
    }
  },
  components: {
    MenuItem
  }
}
</script>

<style>

</style>
